import React from "react";
import { Main, Body, Box, TextBox } from './commonStyles';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SafeTextToHTML from "../components/SafeTextToHTML";
import { SectionBody } from "./Section";


export default function Welcome({content, windowWidth, smallWindow}) {

    // Images should be standardise to 600 x 400
    const padding = (content.menuPosition === 'Left' && ! smallWindow) ? 250 : 50;
    const maxImageWidth = 600;
    const maxImageHeight = 400;
    const usableWidth = windowWidth - padding;
    const slidesToWidth = usableWidth / maxImageWidth;
    let slidesToShow = 1;

    let ImageWidth = maxImageWidth;
    let ImageHeight = maxImageHeight;

    if (usableWidth < 600) {
        // narrow with - shrink width and scale height accordingly
        ImageWidth = usableWidth;
        ImageHeight = Math.floor(maxImageHeight * ImageWidth / maxImageWidth);

    } else if (slidesToWidth % 1 > 0.3) {
        // scale image width to best fit space
        slidesToShow = Math.ceil(slidesToWidth);
        const scaleRatio = slidesToWidth / slidesToShow;
        ImageWidth = Math.floor(maxImageWidth * scaleRatio * 0.9);
        ImageHeight = Math.floor(maxImageHeight * scaleRatio * 0.9);
        
    } else {
        // leave Image width and height at max
        slidesToShow =  Math.floor(slidesToWidth)
    }

    // Don't try to show more than twice the number of images as layout gets messed up
    slidesToShow = Math.min(slidesToShow, content.welcome.welcomeImages.length * 2);

    const settings = {
        dots: false,
        infinite: true,
        speed: 1,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToShow,
        autoplay: true,
        autoplaySpeed: 8000,
        arrows: false
      };

    
    return(
        <>
        {(content.welcome.welcomeImages.length === 0) ? null 
            :
            (content.welcome.welcomeImages.length === 1) ? 
                <Main content={content.styles}>
                    <div  style={{alignSelf: 'center'}}>
                        <Body content={{smallWindow: smallWindow}}>
                            <img src={content.imageMap[content.welcome.welcomeImages[0]]} style={{maxWidth: Math.min(maxImageWidth, usableWidth)}} alt='Welcome'/>
                        </Body>
                    </div>
                </Main>
            :
                <div style={{marginLeft: "auto", marginRight: "auto", marginTop: "20px", marginBottom: "20px", maxWidth: slidesToShow * ImageWidth}}>
                    <div className="slider-container" style={{zIndex:1}}>
                        <Slider {...settings}>
                            {content.welcome.welcomeImages.map((item) => {
                                return (
                                    <div key={item}><img src={content.imageMap[item]} alt={item} width={ImageWidth*.98} height={ImageHeight*.98}/></div>
                                )
                            })}
                        </Slider>
                    </div>
                </div>
        }

        <Main content={content.styles}>
                <Body content={{smallWindow: smallWindow}}>
                    <Box content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                        <TextBox>
                            {(content.welcomeSearchTitle && content.welcomeSearchTitle.length > 0) ?
                                <h1 style={{color: content.styles.textBoxHighlightColor, marginBottom: '20px'}}>{content.welcomeSearchTitle}</h1>
                            : null}
                            {(content.welcome.text && content.welcome.text.length > 0) ?
                                <SafeTextToHTML text={content.welcome.text} />
                            : null }
                        </TextBox>
                    </Box>
                </Body>
        </Main>

        {(content.welcome.sections && content.welcome.sections.length > 0) ?
            <Main content={content.styles}>
                <SectionBody content={content} smallWindow={smallWindow} section={'welcome'} windowWidth={windowWidth} />
            </Main>
        : null
        }

        </>
    )
}
